import React, { useState } from 'react';

import {
    Text,
    Radio,
    Spacer,
} from '@zillow/constellation';

import {
    StyledRadioTitle,
    StyledRadioContainer,
} from './StyledComponents';

const HousingConnector = ({ initSelectedOption, handleSelectChange }) => {
    const OPTIONS = {
        GLOBAL: 'global',
        DISABLED: 'disabled',
        EXCLUSIVE: 'exclusive',
    };

    const [selectedOption, setSelectedOption] = useState(initSelectedOption);

    const title = 'Where to post this listing';
    const description = 'Zillow Rental Network sites include HotPads, Trulia, Zillow. ' +
        'Housing Connector will share your listing with nonprofit agencies and ' +
        'display the modified screening criteria that you specified.';
    const contentGlobal = 'Both Zillow Rental Network and Housing Connector';
    const contentDisabled = 'Only Zillow Rental Network';
    const contentExclusive = 'Only Housing Connector';

    const handleChange = (selected) => {
        setSelectedOption(selected);
        handleSelectChange('seattleHousingConnectorStatus', selected);
    };

    return (
        <div className="HousingConnector">
            <Text
                as="div"
                fontType="h4"
                marginBottom="xs"
                mediaQuery={{
                    md: {
                        marginBottom: 'sm',
                    },
                }}
            >
                {title}
            </Text>

            <Text
                as="div"
                fontType="body"
                marginBottom="lg"
            >
                {description}
            </Text>

            <div className="HousingConnector-FormField-Container">
                <StyledRadioContainer marginBottom="sm">
                    <StyledRadioTitle
                        as="div"
                        fontType="body"
                        marginRight="md"
                    >
                        {contentGlobal}
                    </StyledRadioTitle>

                    <Radio
                        checked={selectedOption === OPTIONS.GLOBAL}
                        onChange={() => handleChange(OPTIONS.GLOBAL)}
                    />
                </StyledRadioContainer>

                <StyledRadioContainer marginBottom="sm">
                    <StyledRadioTitle
                        as="div"
                        fontType="body"
                        marginRight="md"
                    >
                        {contentDisabled}
                    </StyledRadioTitle>

                    <Radio
                        checked={selectedOption === OPTIONS.DISABLED}
                        onChange={() => handleChange(OPTIONS.DISABLED)}
                    />
                </StyledRadioContainer>

                <StyledRadioContainer marginBottom="sm">
                    <StyledRadioTitle
                        as="div"
                        fontType="body"
                        marginRight="md"
                    >
                        {contentExclusive}
                    </StyledRadioTitle>

                    <Radio
                        checked={selectedOption === OPTIONS.EXCLUSIVE}
                        onChange={() => handleChange(OPTIONS.EXCLUSIVE)}
                    />
                </StyledRadioContainer>

                <Spacer marginY="lg" />
            </div>
        </div>
    );
};

export default HousingConnector;
